import EN from "../Lang/En/translate.json";
import KH from "../Lang/Kh/translate.json";

// export const translateLauguage = (lang) => {
//   let language = JSON.parse(JSON.stringify(EN));
//   if (lang === "kh") {
//     language = JSON.parse(JSON.stringify(KH));
//   }

//   const t = (e) => {
//     return language[e];
//   };

//   return { t };
// };

export const translateLauguage = (lang) => {
  let language = JSON.parse(JSON.stringify(EN));
  if (lang === "kh") {
    language = JSON.parse(JSON.stringify(KH));
  }

  const t = (e) => {
    return language[e];
  };

  return { t };
};
